export const BASE_URL = process.env.VUE_APP_API_URL
export const BASE_IMAGE_URL = process.env.VUE_APP_IMAGE_API_URL
